import { useTheme } from "@hooks";
import { InfoIconProps } from "./types";

export const InfoIcon = ({ onClick, size = 34, color }: InfoIconProps) => {
  const { theme } = useTheme();

  const fill = color ?? theme.icon.default;

  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
        onClick?.();
      }}
      style={{ display: "inline-flex", cursor: onClick ? "pointer" : undefined }}
    >
      <svg
        width={size}
        height={(size * 34) / 35}
        viewBox="0 0 35 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_7305_113707)">
          <path
            d="M16.5439 24.0835H18.6689V15.5835H16.5439V24.0835ZM17.4995 12.9627C17.8305 12.9627 18.1081 12.8541 18.3325 12.6368C18.5568 12.4196 18.6689 12.1504 18.6689 11.8293C18.6689 11.4881 18.557 11.2022 18.3331 10.9714C18.1092 10.7406 17.8318 10.6252 17.5008 10.6252C17.1698 10.6252 16.8922 10.7406 16.6679 10.9714C16.4436 11.2022 16.3314 11.4881 16.3314 11.8293C16.3314 12.1504 16.4434 12.4196 16.6672 12.6368C16.8911 12.8541 17.1686 12.9627 17.4995 12.9627ZM17.5096 31.1668C15.5561 31.1668 13.7204 30.795 12.0023 30.0512C10.2842 29.3075 8.78176 28.2922 7.49495 27.0054C6.20815 25.7186 5.19287 24.2152 4.44912 22.4954C3.70537 20.7755 3.3335 18.9379 3.3335 16.9825C3.3335 15.027 3.70537 13.1894 4.44912 11.4695C5.19287 9.74967 6.20815 8.25225 7.49495 6.97725C8.78176 5.70225 10.2851 4.69287 12.0049 3.94912C13.7248 3.20537 15.5624 2.8335 17.5179 2.8335C19.4733 2.8335 21.311 3.20537 23.0308 3.94912C24.7507 4.69287 26.2481 5.70225 27.5231 6.97725C28.7981 8.25225 29.8075 9.75155 30.5512 11.4752C31.295 13.1988 31.6668 15.0373 31.6668 16.9907C31.6668 18.9442 31.295 20.7799 30.5512 22.498C29.8075 24.2161 28.7981 25.7164 27.5231 26.9989C26.2481 28.2813 24.7488 29.2966 23.0252 30.0447C21.3016 30.7928 19.463 31.1668 17.5096 31.1668ZM17.5179 29.0418C20.8588 29.0418 23.6981 27.8672 26.0356 25.5179C28.3731 23.1686 29.5418 20.3234 29.5418 16.9825C29.5418 13.6415 28.3753 10.8022 26.0422 8.46475C23.7092 6.12725 20.8618 4.9585 17.5002 4.9585C14.171 4.9585 11.3318 6.12503 8.98245 8.45809C6.63315 10.7912 5.4585 13.6385 5.4585 17.0002C5.4585 20.3293 6.63315 23.1686 8.98245 25.5179C11.3318 27.8672 14.1769 29.0418 17.5179 29.0418Z"
            fill={fill}
          />
        </g>
        <defs>
          <clipPath id="clip0_7305_113707">
            <rect width="34" height="34" fill="white" transform="translate(0.5)" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};
